(function () {
  'use strict';

  angular.module('eclipseApp.core')
    .filter('bytesUnitConverter', function () {
      return function (bytes, unit, precision) {
        var units = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb'];

        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return {};
        if ( bytes=== 0 || bytes === 0.0) {
          return {
            "value": parseFloat(0.0),
            "unit": units[2]
          };
        }
        if (unit !== "KB") return {};
        bytes = bytes * 1024;
        if (typeof precision === 'undefined') precision = 2;

        var number = Math.floor(Math.log(bytes) / Math.log(1024));

        var value = (bytes / Math.pow(1024, Math.floor(number)));
        var decimalLength = value.toString().split(".")[0].length;


        switch (decimalLength) {
          case 3:
            value = value.toFixed(0);
            break;
          case 2:
            value = value.toFixed(2);
            break;
          default:
            value = value.toFixed(precision);
        }

        return {
          "value": parseFloat(value),
          "unit": units[number]
        }

      }
    })
    .filter('convertUomToKB', function () {
      return function (data, unit) {
        if (isNaN(parseFloat(data)) || !isFinite(data)) return null;

        var units = ['kb','mb', 'gb', 'tb', 'pb'];
        var index = units.indexOf(unit.toLowerCase());

        if (index !== -1) {
          return data * Math.pow(1024, index);
        }
        else{
          return null;
        }

      }
    })
    .filter('getOverageQuantity', function () {
      return function (overage, featureVolume) {
        if (isNaN(parseFloat(overage)) || !isFinite(overage)) return null;
        if (isNaN(parseFloat(featureVolume)) || !isFinite(featureVolume)) return null;

        return Math.ceil(overage/featureVolume);

      }
    })
    .controller('usageDialRealtimeCtrl', [
      '$scope',
      '$state',
      '$rootScope',
      '$http',
      '$stateParams',
      '$window',
      'env',
      'uteLocale',
      'uteModal',
      'brtSwitchCMS',
      '$filter',
      'util',
      'permissionsService',
      'dataExtraAPIService',
      'dataLayerService',
      function ($scope,
                $state,
                $rootScope,
                $http,
                $stateParams,
                $window,
                env,
                uteLocale,
                uteModal,
                brtSwitchCMS,
                $filter,
                util,
                permissionsService,
                dataExtraAPIService,
                dataLayerService) {

        function trackDialStatus(name ){
          var AnalyticsDataLayer = {
            'account': dataLayerService.getAccountInfo(),
            'selfServe':{
              'type' : 'inquiry',
              'name' : name
            },
            'events': {
              'selfServeComplete':true
            }
          }

          dataLayerService.trackDataLayer(AnalyticsDataLayer);
        }

        console.log($scope.dialData);
        $scope.addOnShow = false;
        $scope.showInfoPopup = false;

        $scope.localString= uteLocale.language+'-CA';
        $scope.lang= uteLocale.language;
        $scope.showHR = false;
        $scope.viewFlag = false;
        $scope.overageUnderDial = false;

        function findPropertyForDataDialForMonitor(obj) {
          var returnObj = {};
          switch(true) {
            case (obj.overage > 0 && obj.remaining > 0) || (obj.overage <= 0 && obj.remaining >= 0) :
              $scope.overageUnderDial = (obj.overage > 0 && obj.remaining > 0) ? true : false;
              var percent = 0;
              percent = 100 - Math.ceil(obj.remaining * 100 / obj.total);
              returnObj= {
               stateAnalytics: "balance",
               propName: "remaining",
               propValue: obj.remaining,
               propStatus: "remaining",
               propPercent: percent
             };
            break;
            case (obj.overage > 0 && obj.remaining <= 0) :
              returnObj= {
                stateAnalytics: "overage",
                propName: "overage",
                propValue: obj.overage,
                propStatus: "in_overage",
                propPercent: 101
              };
            break;
            default:
                returnObj =  null;
            }
            return returnObj;
        }

        function findPropertyForDial(obj){
            var retunObj = {};
            switch(true){
              case obj.total === -0.01 :
                retunObj=  {
                  stateAnalytics: "balance",
                  propName: "unlimited",
                  propValue: null,
                  propStatus: "unlimited",
                  propPercent: 0
                };
                break;
              case obj.overage === 0 :
                var percent = 0;
                var remaining = obj.remaining;
                if(obj.hasOwnProperty('used') && obj.hasOwnProperty('total')  && ( obj.used <= obj.total ) ) {
                  percent = Math.ceil(obj.used * 100 / obj.total);
                  remaining = obj.remaining;
                }
                if(obj.remaining <= 0){
                  percent = 100;
                  remaining = 0;
                }

                retunObj= {
                  stateAnalytics: "balance",
                  propName: "remaining",
                  propValue: remaining,
                  propStatus: "remaining",
                  propPercent: percent
                };
                break;

              case obj.overage >= 0 :
                retunObj= {
                  stateAnalytics: "overage",
                  propName: "overage",
                  propValue: obj.overage,
                  propStatus: "in_overage",
                  propPercent: 101
                };
                break;
              default:
                retunObj =  null;
            }
            return retunObj;
        }


        function displayOverageInUpdates() {

          if($scope.status ==="in_overage" || $scope.overageUnderDial){

            var valueForOverage = $scope.dialData.wirelessUsageSummaryInfoList[0].overage;
            var uomForOverage = $scope.dialData.wirelessUsageSummaryInfoList[0].uom.toLowerCase();

            var valueForFeature = $scope.overageRate.featureVolume;
            var uomForFeature =  $scope.overageRate.featureUnit.displayNameEn.toLowerCase();


            var overageInKB = $filter('convertUomToKB')(valueForOverage , uomForOverage);
            var featureVolumeInKB = $filter('convertUomToKB')(valueForFeature , uomForFeature);


            $scope.overageCharge = {
              'quantity': $filter('getOverageQuantity')(overageInKB, featureVolumeInKB ),
              'data' : $scope.overageRate.featureVolume,
              'price' : $scope.overageRate.featurePrice,
              'uom':  $scope.overageRate.featureUnit.displayNameEn
            };
            $scope.overageChargeAvailable = true ;

            $scope.showHR = true;


          }

        }


        $scope.onlyRowInMiddle = false;
        $scope.isUnlimited = false;
        $scope.isNA = false;
        $scope.realTimeVisible = false;

        var dataObject;
        var prop;
        var convertedUnit;

        var x_session_token = $window.localStorage.getItem("x_session_token");
        var janrainCaptureProfileData = $window.localStorage.getItem("easyLoginDataJanrain");
        var profileId = janrainCaptureProfileData !== null ? janrainCaptureProfileData.uuid : '';
        var userId = janrainCaptureProfileData !== null ? JSON.parse(janrainCaptureProfileData).userID : '';


        console.log("BAN :", $rootScope.userInfo.selectedAccountNumber);
        console.log("CTN :", $rootScope.userInfo.selectedSubscriberNo);

        $scope.selectedBan = $rootScope.userInfo.selectedAccountNumber;
        $scope.selectedCTN = $rootScope.userInfo.selectedSubscriberNo;

        $scope.upSellEligibility = function () {
          $http({
            method: 'POST',
            url: env.genesisApiURL + 'uep/v1/upsellEligibility',
            headers: {
              'x-session-token': x_session_token,
              'x-app-id': 'Fido',
              'userId': userId,
              'profileId': profileId
            },
            data: {
              ctn: $scope.selectedCTN,
              accountNumber: $scope.selectedBan,
              language: uteLocale.language,
              region: uteLocale.province
            },
            withCredentials: false


          }).success(function (data) {
            console.log('data.content.upsellEligibility:', data.content.upsellEligibility);
            if (!data && !data.content) {
              $scope.addOnEnabled = false;
              return;
            }
            if (data.content.upsellEligibility) {
              $scope.addOnEnabled = true;

            } else {
              $scope.addOnEnabled = false;
              switch (data.content.reasonCode) {
                case "1":
                //  $scope.dataOverage = true;  DC-1122 - DTU - Remove Overage Message on fido.ca  
                  break;
                case "2":
                  $scope.addOnExceeded = true;
                  break;
                default:
              }

            }
          }).error(function (data) {
            $scope.addOnEnabled = false;
          });

        };

        $scope.showAddDataInfoPopup = function () {
          $scope.showInfoPopup = !$scope.showInfoPopup;

          util.bindBodyClickToHideSection($scope, 'showInfoPopup', '#showDataInfoTooltip', '#dataInfoTooltip');
        };

        $scope.init = function() {
        switch ($scope.type) {

          case "data":

              $scope.dial_label_type ="data";
              if (!$scope.dialEligible) {
                $scope.onlyRowInMiddle = true;
                $scope.propPercent = 100;
                break;
              }

            $scope.$watch(function () { return dataExtraAPIService.getDataExtraList(); }, function (newValue) {
              $scope.dataExtrasList = newValue;
              if($scope.dataExtrasList > 0 ){
                $scope.showHR = true;
              }
            });

            $scope.$watch(function () { return dataExtraAPIService.getOverageRate(); }, function (newValue) {
                $scope.overageRate = newValue;
                displayOverageInUpdates();
            });

            dataObject = $scope.dialData.wirelessUsageSummaryInfoList[0];


            if($scope.dialData['statusCode'] === "1" || $scope.dialData['statusCode'] === "4" || $scope.dialData['statusCode'] === "5" ){
              prop = {
                stateAnalytics: "balance",
                propName: "used",
                propValue: dataObject.used,
                propStatus: "used",
                propPercent: 100
              };
            }
            else if ($scope.dialData['statusCode'] === "0" || $scope.dialData['statusCode'] === "3") {
              prop = findPropertyForDataDialForMonitor(dataObject);
            }
            else{
              prop = findPropertyForDial(dataObject);
            }

            if(prop && prop !== null){
                if ( prop.propName === "unlimited"  ) {
                  $scope.onlyRowInMiddle = true ;
                  $scope.isUnlimited = true ;

                }
                else{
                  convertedUnit = $filter('bytesUnitConverter')(prop.propValue, dataObject.uom);
                  if(convertedUnit.hasOwnProperty('value') && convertedUnit.hasOwnProperty('unit') ){
                    $scope.value = convertedUnit.value;
                    $scope.unit = "global.unit."+ convertedUnit.unit;
                    $scope.status = prop.propStatus;
                  }
                }
                $scope.propPercent = prop.propPercent;

                if($scope.dialData['statusCode'] === "2" || $scope.dialData['statusCode'] === "3"){
                    $scope.more_info = "up_to_12h_dl";
                }
                else{
                    if($scope.dialData["realTime"]){
                      $scope.more_info = "real_time";
                    }
                    else{
                      $scope.more_info = "up_to_1h_dl";
                    }
                }

                $scope.realTimeVisible = true;
               trackDialStatus('view rt mobile data usage-'+prop.stateAnalytics);

            }

            break;

          case "talk":

            $scope.dial_label_type ="talk";

            if($scope.dialData.length > 0){

              dataObject = $filter('filter')($scope.dialData, {total: !-0.01 }, true)[0];

              if(!dataObject){
                dataObject = $scope.dialData[0];
              }
              prop = findPropertyForDial(dataObject);
              if (prop && prop !== null) {
                if (prop.propName === "unlimited") {
                  $scope.onlyRowInMiddle = true;
                  $scope.isUnlimited = true ;

                }
                else if (prop.propName === "overage"){
                  $scope.value = 0;
                  $scope.unit = "MIN";
                  $scope.status = "remaining";
                  $scope.more_info_value = dataObject.total;
                  $scope.more_info = "included";
                }
                else {
                  $scope.value = dataObject[prop.propName];
                  $scope.unit = "MIN";
                  $scope.status = prop.propStatus;
                  $scope.more_info_value = dataObject.total;
                  $scope.more_info = "included";
                }
                $scope.propPercent = prop.propPercent;

                trackDialStatus('view rt mobile talk usage-'+prop.stateAnalytics);

              }
            }
            else if (!$scope.dialEligible) {
              $scope.onlyRowInMiddle = true;
              $scope.propPercent = 100;
            }
            else{
              $scope.onlyRowInMiddle = true;
              $scope.isNA = true;
              $scope.propPercent = 100;

            }

            break;

          case "text":

            $scope.dial_label_type ="uep_dial_text";

            if($scope.dialData.length > 0){

              dataObject = $filter('filter')($scope.dialData, {total: !-0.01}, true)[0];

              if(!dataObject){
                dataObject = $scope.dialData[0];
              }

              prop = findPropertyForDial(dataObject);
              if (prop && prop !== null) {
                if (prop.propName === "unlimited") {
                  $scope.onlyRowInMiddle = true;
                  $scope.isUnlimited = true ;
                }
                else if (prop.propName === "overage"){
                  $scope.value = 0;
                  $scope.unit = '';
                  $scope.status = "remaining";
                  $scope.more_info_value = dataObject.total;
                  $scope.more_info = "included";
                }
                else {
                  $scope.value = dataObject[prop.propName];
                  $scope.unit = '';
                  $scope.status = prop.propStatus;
                  $scope.more_info_value = dataObject.total;
                  $scope.more_info = "included";
                }
                $scope.propPercent = prop.propPercent;

                trackDialStatus('view rt mobile text usage-'+prop.stateAnalytics);

              }

            }
            else if (!$scope.dialEligible) {
              $scope.onlyRowInMiddle = true;
              $scope.propPercent = 100;
            }
            else{
              $scope.onlyRowInMiddle = true;
              $scope.isNA = true;
              $scope.propPercent = 100;
            }
            break;
          default:
        }
        if ($scope.type === 'data') {
          //Added for Add Topup BRT
          if(permissionsService.permissionDetail.isAddTopupBRT){
            $scope.showAddData = true;
          }
          //Added for Add Topup BRT
          if(!permissionsService.permissionDetail.isFidoDisableAllUsage){
            $scope.upSellEligibility();
          }
          else {
            if ($window.localStorage.getItem('usageRefresh')) {
              $scope.upSellEligibility();
            }
          }
        }
        };

        $scope.$watch('dialEligible', function(newVal, oldVal) {
          if (!newVal) {
            $scope.init();
          }
        });
        $scope.viewAddonsToggle =  function(){
          $scope.viewFlag = !$scope.viewFlag;
        }

        $scope.launchManageData = function() {
          $state.go('myAccount.manageData', {
            selectedBAN: $scope.selectedBan,
            selectedCTN: $scope.selectedCTN
          });
        } 


        $scope.init();

      }

    ])
  ;
})
();
